export default function normalizePhone(phone: string) {
  if (!phone) {
    return ''
  }
  return (phone.startsWith('+') ? '+' : '') + phone.replaceAll(/\W+/g, '')
}
